// Add class to header if hero is used on page
var hero = document.querySelector('.section.hero');
var body = document.querySelector('body');
var heroLight = document.querySelector('.section.hero.lightblue');
var heroBlueEdge = document.querySelector('.section.hero.blue-edge');

if(hero){
   body.classList.add('hero-bg'); 
} 
if(heroLight){
   body.classList.add('hero-bg-light'); 
} 
if(heroBlueEdge){
   body.classList.remove('hero-bg'); 
   body.classList.add('hero-blue-edge'); 
} 